<div class="wrapper">
  <mat-card appearance="outlined">
    <mat-card-header class="text-uppercase tal">
      <mat-card-title>{{'queue.details' | translate}}
        <span class="close">
          <button class="close-btn" (click)="closeDialog()">
            <cqes-icon icon="close"></cqes-icon>
          </button>
        </span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="container">
      <div class="row">
        <div class="col-12">
          <div class="container">
            <ng-template [ngIf]="wait" [ngIfElse]="requestedDetailsTemplate">
              <div class="row">
                <div class="col-4 col-centered">
                  <mat-spinner></mat-spinner>
                </div>
              </div>
            </ng-template>
            <ng-template #requestedDetailsTemplate>
              <div class="row">
                <div class="col-12">
                  <div class="cert-details-section">

                    <div class="row">
                      <div class="col-md-1 label ">{{'queue.status' | translate}}</div>
                      <div class="col-md-2 label ">{{'queue.signDate' | translate}}</div>
                      <div class="col-md-2 label ">{{'queue.signBefore' | translate}}</div>
                      <div class="col-md-4 label ">{{'queue.name' | translate}}</div>
                      <div class="col-md-1 label ">{{'common.actions' | translate}}</div>
                    </div>

                    <div *ngFor="let item of requestedDetails">
                      <mat-divider></mat-divider>
                      <div class="row">
                        <div class="col-md-1">
                          <cqes-icon [icon]="item.statusIcon.icon" [iconClass]="item.statusIcon.colorClass" class="status"></cqes-icon>
                        </div>
                        <div class="col-md-2">{{item.signDate | date: dateFormat}}
                          <br> {{item.signDate | date: timeFormat}} </div>
                        <div class="col-md-2">{{item.deadLineTs | date: dateFormat}}
                          <br> {{item.deadLineTs | date: timeFormat}} </div>
                        <div class="col-md-4">{{displayUserName(item)}}</div>
                        <div class="col-md-1" class="btn-wrapper btnDownload">
                          <button class="mat-mdc-raised-button accent action-button" (click)="onDownloadFile(item)" *ngIf="hasFileForDownload(item)">
                            <cqes-icon icon="file_download" class="download"></cqes-icon>
                            {{'historyTexts.downloadDocument' | translate}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" id="save-btn-row">
                <div class="col-12">
                  <div class="btn-wrapper">
                    <button class="mat-mdc-raised-button accent action-button" (click)="closeDialog()">{{'close'|translate}}
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
